import type { FCP, TAutosuggestPayload } from 'types';

import AutosuggestInput from 'components/autosuggestInput';
import Ratings from 'components/ratings';

import { IQuestion, QType } from './types';

interface ICompanyAnonReviewFormSectionProps extends FCP {
  questionType: QType;
  questions: IQuestion[];
  onSubmitAnswer?(questionId: string, answer?: string): void;
  labelClassName?: string;
  questionClassName?: string;
  questionAnswerMap?: {
    [questionId: string]: string;
  }; // Map of questionId and answer
}

type TQuestionProps = Pick<ICompanyAnonReviewFormSectionProps, 'onSubmitAnswer'> & {
  question: IQuestion;
  answer?: string;
};

const RatingBasedQuestion = ({ question, answer = '', onSubmitAnswer }: TQuestionProps) => (
  <Ratings
    smallStar={true}
    colorClass={'blue'}
    ratingIndex={answer ? parseInt(answer) - 1 : -1} // index starts from 0 to 4
    customClasses={{ star: 'emptyStar', container: 'unsetJustify' }}
    onRate={(rating) => onSubmitAnswer(question.id, String(rating + 1))}
  />
);

const TextBasedQuestion = ({ question, answer = '', onSubmitAnswer }: TQuestionProps) => (
  <textarea
    rows={4}
    value={answer || ''}
    placeholder={question.placeholder}
    onChange={(e) => onSubmitAnswer(question.id, e.target.value)}
  />
);

const AutosuggestQuestion = ({ question, answer = '', onSubmitAnswer }: TQuestionProps) => (
  <AutosuggestInput
    category={question.key === 'title' ? 'jobTitle' : 'location'}
    prefillValue={answer}
    inputProps={{
      name: question.key === 'title' ? 'company_jobTitle' : 'company_location',
    }}
    onChange={(payload: TAutosuggestPayload) => {
      if (payload.suggestionSelected) {
        onSubmitAnswer(question.id, payload.displayValue);
      }
    }}
  />
);

const ReviewQuestion = (props: TQuestionProps & { questionType: QType }) => {
  switch (props.questionType) {
    case 'five_star_select':
      return <RatingBasedQuestion {...props} />;
    case 'textbox':
      return <TextBasedQuestion {...props} />;
    case 'autosuggest':
      return <AutosuggestQuestion {...props} />;
    default:
      return null;
  }
};

const CompanyAnonReviewFormSection = ({
  questions,
  questionType,
  onSubmitAnswer,
  questionAnswerMap = {},
  className = '',
  questionClassName = '',
  labelClassName = '',
}: ICompanyAnonReviewFormSectionProps) => {
  return (
    <div className={className}>
      {questions.map((question) => (
        <div key={question.id} className={questionClassName}>
          <label className={labelClassName}>{question.label} </label>
          <ReviewQuestion
            question={question}
            questionType={questionType}
            answer={questionAnswerMap[question.id] || ''}
            onSubmitAnswer={onSubmitAnswer}
          />
        </div>
      ))}
    </div>
  );
};

export default CompanyAnonReviewFormSection;
